import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { WaterTowersService } from '../../service/api/water-towers-service';
import { format } from 'date-fns';
import { ACTION_MODE } from '../../core/constants/constants';

const formatDate = date => {
  if (!date) return '';
  try {
    return format(new Date(date), 'MM/dd/yyyy');
  } catch (err) {
    console.error('Invalid date:', date);
    return '';
  }
};

const SafetyChecklistHistory = ({ data, onChanges, onCloseModal, waterTowerId, onActionClick }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [safetyData, setSafetyData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSafetyChecklistHistory();
  }, [waterTowerId]);

  const fetchSafetyChecklistHistory = async () => {
    if (!waterTowerId) return;
    
    try {
      setLoading(true);
      const response = await WaterTowersService.getWaterTowerSafetyChecklistByWaterTower(waterTowerId);
      if (response.status === 200 && response.response) {
        const formattedData = response.response.map((item, index) => ({
          key: item.id || index,
          id: item.id,
          date: item.date,
          type: 'Safety Check',
          currentData: item,
        }));
        setSafetyData(formattedData);
      }
    } catch (error) {
      console.error('Error fetching safety checklist history:', error);
      setSafetyData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (record) => {
    if (onActionClick) {
      onActionClick(ACTION_MODE.VIEW);
    }
  };

  const handleCopyToCell = (record) => {
    if (onActionClick) {
      onActionClick({ ...record.currentData, id: 0 }, ACTION_MODE.COPY_TO_CELL);
    }
  };

  const columns = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: text => formatDate(text),
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      render: (text) => (
        <span 
          className="badge" 
          style={{
            backgroundColor: '#d4edda',
            color: '#155724',
            padding: '5px 12px',
            borderRadius: '4px',
            fontSize: '13px',
          }}
        >
          {text}
        </span>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <div className="d-flex gap-2">
          <button
            className="btn btn-sm"
            style={{
              backgroundColor: '#e9ecef',
              color: '#495057',
              border: 'none',
              padding: '5px 15px',
              borderRadius: '4px',
            }}
            onClick={() => handleView(record)}
          >
            View
          </button>
          <button
            className="btn btn-sm"
            style={{
              backgroundColor: '#e9ecef',
              color: '#495057',
              border: 'none',
              padding: '5px 15px',
              borderRadius: '4px',
            }}
            onClick={() => handleCopyToCell(record)}
          >
            Copy to Cell
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <Table
            columns={columns}
            dataSource={safetyData}
            loading={loading}
            pagination={{
              current: currentPage,
              pageSize: 10,
              onChange: (page) => setCurrentPage(page),
              showSizeChanger: false,
              size: 'default',
            }}
          />
        </div>
      </div>
    </div>
  );
};

SafetyChecklistHistory.propTypes = {
  data: PropTypes.object,
  onChanges: PropTypes.func,
  onCloseModal: PropTypes.func,
  waterTowerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onActionClick: PropTypes.func,
};

export default SafetyChecklistHistory;
